import React from 'react';
import { Alert } from '@mui/material';

type TicketCardErrorsProps = {
  errors: Array<string | null>;
};

const TicketCardErrors: React.FC<TicketCardErrorsProps> = React.memo(({ errors }) => {
  const visibleErrors = errors.filter((error) => Boolean(error)) as string[];

  if (visibleErrors.length === 0) {
    return null;
  }

  return (
    <>
      {visibleErrors.map((error) => (
        <Alert key={error} severity="error" className="alert">
          {error}
        </Alert>
      ))}
    </>
  );
});

TicketCardErrors.displayName = 'TicketCardErrors';

export default TicketCardErrors;
